export const SERVER_REQUEST_STATUS = {
  PENDING: 'PENDING',
  FULFILLED: 'FULFILLED',
  REJECTED: 'REJECTED'
};

export const AUTH_STATUS = {
  VALIDATE_TOKEN_PENDING: 'VALIDATE_TOKEN_PENDING',
  VALIDATE_TOKEN_FULFILLED: 'VALIDATE_TOKEN_FULFILLED',
  VALIDATE_TOKEN_REJECTED: 'VALIDATE_TOKEN_REJECTED',
  MISSING_TOKEN: 'MISSING_TOKEN'
};

export const APP_ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SMS: '/sms',
  MEDICAL_HISTORY: '/medical-history',
  RELEASE_DOCS: '/release-docs',
  VISIT_SUMMARY: '/visit-summary',
  ER_SUMMARY: '/er-summary',
  RADIOLOGY: '/radiology',
  LAB: '/lab'
};

export enum MEDICAL_HISTORY {
  RELEASE_DOCS = 'RELEASE_DOCS',
  VISIT_SUMMARY = 'VISIT_SUMMARY',
  ER_SUMMARY = 'ER_SUMMARY',
  RADIOLOGY = 'RADIOLOGY',
  LAB = 'LAB',
  HOME = 'homePage'
}

export enum DOCUMENT_TYPE_KEY {
  RELEASE_DOCS = '1',
  VISIT_SUMMARY = '2',
  ER_SUMMARY = '3'
}

export const INTERVAL_DELAY = 15000;

export enum USER_ACTIVITY_EVENT {
  VIEW = 'VIEW',
  DOWNLOAD = 'DOWNLOAD',
  SHARE = 'SHARE',
  LOGIN = 'LOGIN'
}

export enum USER_ACTIVITY_TYPE {
  SCREEN = 'SCREEN',
  PDF = 'PDF',
  ZIMUN_TORIM = 'ZIMUN_TORIM'
}

export enum USER_ACTIVITY_USER_TYPE {
  PATIENT = 'PATIENT',
  ACCOMAPNY = 'ACCOMAPNY',
  MEDICAL_TEAM = 'MEDICAL_TEAM'
}

export enum FORM_TYPE {
  SMS = 'SMS',
  LOGIN = 'LOGIN'
}

export const FONT_SIZES = [1, 1.5, 2];

export const DEFAULT_LANGUAGE = 'he';

const MINUTE = 60000;

export const LOGOUT_TIMER = MINUTE * 5;

export const REACT_APP_HOSPITAL_CODE = process.env.REACT_APP_HOSPITAL_CODE;

export enum MEDIA_QUERIES {
  MOBILE = 768,
  TABLET = 957,
  DESKTOP = 1284
}

export enum NOTIFICATION_TYPE {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error'
}
